var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step"},[_c('b-alert',{attrs:{"variant":"info","show":!_vm.hasAddress}},[_vm._v("Geen adres gevonden!")]),(_vm.title)?_c('div',{staticClass:"step__header"},[_c('h4',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._t("default"),_c('div',{staticClass:"step__footer mt-2"},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }